import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ReportTypeEnum } from 'fragments';
import { AddressInput, ButtonMain, InputMain } from 'components';
import { useWindowSize } from 'utils';
import { Svg } from 'assets';

export const HomeBanner = ({ handleSubmit, onSubmit, control, setValue, reportType, isFRV, handleChangeFrvOrFmv }) => {
  const [width] = useWindowSize();


  return (
    <div className='home-banner-wrapper'>
      <div className='container'>
        <div className='home-banner-box'>
          <h1 className='banner-title'>
            Maximize FRV & FMV Accuracy with AI
          </h1>

          <p className='banner-description'>
            Enhance your property assessments—experience the ClaimFRV advantage in both FRV and FMV reports.
          </p>

          {width > 1279 &&
            <form className='address-email-radio-wrapper' onSubmit={handleSubmit(onSubmit)}>
              <RadioGroup
                aria-labelledby='demo-radio-buttons-group-label'
                className={'address-email-radio-buttons-group'}
                defaultValue='FRV'
                name='radio-buttons-group'
                onChange={(e) => handleChangeFrvOrFmv(e.target.value)}
              >
                <FormControlLabel
                  value={ReportTypeEnum.FRV}
                  className={isFRV ? 'address-email-radio-buttons-form-active radio-buttons-frv-active' : ''}
                  control={
                    <Radio
                      sx={{
                        color: '#D0D5DD',
                        '&.Mui-checked': {
                          color: '#0C66E4',
                        },
                      }}
                    />
                  }
                  label='Fair Rental Value Report'
                />
                <FormControlLabel
                  value={ReportTypeEnum.FMV}
                  className={!isFRV ? 'address-email-radio-buttons-form-active radio-buttons-fmv-active' : ''}
                  control={
                    <Radio
                      sx={{
                        color: '#D0D5DD',
                        '&.Mui-checked': {
                          color: '#0C66E4',
                        },
                      }}
                    />}
                  label='Fair Market Value Report'
                />
              </RadioGroup>

              <div className='address-email-button'>
                <AddressInput
                  className='banner-input banner-address'
                  control={control}
                  name='address'
                  placeholder='Enter Property Address'
                  customDesign={false}
                  allowError={false}
                  setValue={setValue}
                />

                <InputMain
                  className='banner-input banner-email'
                  control={control}
                  name='email'
                  placeholder='Enter Your Email'
                  customDesign={false}
                  allowError={false}
                />

                <ButtonMain
                  type='submit'
                  startAdornment={<Svg.Listing />}
                  text={width > 1279 ? `Get Your ${reportType} Report Now` : `${reportType} Report`}
                  className='report-button'
                />
              </div>
            </form>
          }
        </div>
      </div>
    </div>
  );
};

